module.exports = __webpack_public_path__ + "static/media/0.6d6f7a66.png";